export default __webpack_public_path__ + "static/media/calls.96c189cb.svg";